import { API_BASE_URL } from '../config/api';
import { createApiError } from './apiError';

interface PasswordResetRequestData {
  email: string;
}

interface PasswordResetResponse {
  message: string;
}

export const requestPasswordReset = async (
  data: PasswordResetRequestData
): Promise<PasswordResetResponse> => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/auth/request-password-reset`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      throw createApiError(
        responseData?.error || 'Password reset request failed',
        responseData?.code
      );
    }

    return responseData;
  } catch (error: any) {
    console.error('Password Reset Request Error:', error);
    throw error;
  }
};

interface ResetPasswordData {
  token: string;
  password: string;
}

interface ResetPasswordResponse {
  message: string;
}

export const resetPassword = async (
  data: ResetPasswordData
): Promise<ResetPasswordResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw createApiError(
        responseData?.error || 'Password reset failed',
        responseData?.code
      );
    }

    return responseData;
  } catch (error: any) {
    console.error('Password Reset Error:', error);
    throw error;
  }
};
